module.exports = __webpack_public_path__ + "img/ef_detail_more_b_znzl.ce82d954.png";